import { liquidGlassRowShadowSx, liquidGlassSurfaceFillSx } from '@focuslee/shared-mini-app';
import { Box } from '@mui/material';
import { FC, ReactNode } from 'react';

interface LiquidGlassRowCardProps {
  children: ReactNode;
  borderRadius?: number;
  style?: React.CSSProperties;
}

export const LiquidGlassRowCard: FC<LiquidGlassRowCardProps> = ({ children, borderRadius = 14, style }) => (
  <Box style={style} sx={{ borderRadius: `${borderRadius}px`, overflow: 'hidden', ...liquidGlassRowShadowSx }}>
    <Box sx={{ borderRadius: 'inherit', ...liquidGlassSurfaceFillSx }}>
      {children}
    </Box>
  </Box>
);
